// extracted by mini-css-extract-plugin
export var equalColumn = "_gl-0";